import axiosInstance from '../axiosInterceptor/axiosInstance'

// Fetches the org's games by their CMS context; the ids must be the org's. At least one of
// seasonId/stageId/groupId/gamedayId must be supplied.
// Returns GameResponse[] (id, gamedayId, status, home/away team + score).
const getGamesByContext = async ({ orgId, seasonId, stageId, groupId, gamedayId } = {}) => {
  const params = new URLSearchParams()
  if (seasonId) params.append('seasonId', seasonId)
  if (stageId) params.append('stageId', stageId)
  if (groupId) params.append('groupId', groupId)
  if (gamedayId) params.append('gamedayId', gamedayId)

  if ([...params.keys()].length === 0) return []

  const response = await axiosInstance.get(`v1/orgs/${orgId}/events/games/by-context?${params.toString()}`)
  return response?.data ?? []
}

export default getGamesByContext
